import { ParameterType } from '@/study-search/enums';

import { DegreeTypeFilterOptionValue, FilterKey } from '@studyportals/search-filters/server-side';
import { Filter } from '../Filter';
import { IIndexation } from '@/study-search/interfaces';

export class DegreeTypeFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.DEGREE_TYPE, ParameterType.DEGREE_TYPE, []);
	}

	public canBeIndexed(): boolean {
		return (
			this.values.length === 1 &&
			(this.values.includes(DegreeTypeFilterOptionValue.DOCTORATE) ||
				this.values.includes(DegreeTypeFilterOptionValue.DBA) ||
				this.values.includes(DegreeTypeFilterOptionValue.PHD) ||
				this.values.includes(DegreeTypeFilterOptionValue.MSC) ||
				this.values.includes(DegreeTypeFilterOptionValue.MA) ||
				this.values.includes(DegreeTypeFilterOptionValue.MBA) ||
				this.values.includes(DegreeTypeFilterOptionValue.LLM) ||
				this.values.includes(DegreeTypeFilterOptionValue.MPHIL) ||
				this.values.includes(DegreeTypeFilterOptionValue.MED) ||
				this.values.includes(DegreeTypeFilterOptionValue.MENG) ||
				this.values.includes(DegreeTypeFilterOptionValue.POSTGRADIP) ||
				this.values.includes(DegreeTypeFilterOptionValue.POSTGRADCERT) ||
				this.values.includes(DegreeTypeFilterOptionValue.PREMASTER) ||
				this.values.includes(DegreeTypeFilterOptionValue.BSC) ||
				this.values.includes(DegreeTypeFilterOptionValue.BA) ||
				this.values.includes(DegreeTypeFilterOptionValue.BBA) ||
				this.values.includes(DegreeTypeFilterOptionValue.ASSOCIATE_DEGREE) ||
				this.values.includes(DegreeTypeFilterOptionValue.GRADUATE_CERTTIFICATE) ||
				this.values.includes(DegreeTypeFilterOptionValue.GRADUATE_DIPLOMA) ||
				this.values.includes(DegreeTypeFilterOptionValue.PREBACHELOR) ||
				this.values.includes(DegreeTypeFilterOptionValue.CERTIFICATE))
		);
	}
}
